import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from 'semantic-ui/semantic-ui-imports';
import './index.scss';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <Header as="h1" className="not-found-page__header">
        {t('notFound.header')}
      </Header>
    </div>
  );
};

export default NotFoundPage;
